import React from "react";
import "./Login.scss";
import { useNavigate } from "react-router-dom";
import useHttp from "../../custom hook/use-http";
import { useTranslation } from "react-i18next";
import { useReducer } from "react";
import { useRef } from "react";
import Input from "../../UI/Input/Input";
import Button from "../../UI/Button/Button";
import { useState, useEffect } from "react";
import { useChangeLanguage } from "../../custom hook/useChangeLanguage";

const validateMobileNumber = (mobile) => {
  return /(^(01)(0|1|2|5)\d{8}$)/.test(mobile);
};

const mobileReducer = (state, action) => {
  if (action.type === "USER_INPUT") {
    return { value: action.val, isValid: validateMobileNumber(action.val) };
  } else if (action.type === "USER_BLUR") {
    return { value: state.value, isValid: validateMobileNumber(state.value) };
  }

  return { value: "", isValid: false };
};

const Login = () => {
  const mobileInputRef = useRef();
  // const passwordInputRef = useRef();

  const arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
  ];

  const fixNumbers = (str) => {
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(arabicNumbers[i], i);
      }
    }
    return str;
  };

  const [mobileState, dispatchMobile] = useReducer(mobileReducer, {
    value: "01",
    isValid: null,
  });

  const [formIsValid, setFormIsValid] = useState(false);
  const [sessionToken, setSessionToken] = useState("");

  const { isValid: mobileIsValid } = mobileState;
  // const { isValid: passwordIsValid } = passwordState;

  const navigate = useNavigate();

  // useHttp
  const { isLoading, error, sendRequest } = useHttp();
  const { t, i18n } = useTranslation();
  const { changeLanguage } = useChangeLanguage();

  useEffect(() => {
    setSessionToken(localStorage.getItem("sessionToken"));
  }, []);

  useEffect(() => {
    const keyStrokeTimeout = setTimeout(() => {
      setFormIsValid(mobileIsValid);
    }, 500);

    return () => {
      clearTimeout(keyStrokeTimeout);
    };
  }, [mobileIsValid]);

  const mobileKeyDownHandler = (event) => {
    if (
      (event.key === "Backspace" && mobileState.value.trim().length < 3) ||
      ((event.keyCode < 48 || event.keyCode > 57) && event.keyCode !== 8)
    ) {
      event.preventDefault();
    }
  };

  const mobileChangeHandler = (event) => {
    dispatchMobile({ type: "USER_INPUT", val: fixNumbers(event.target.value) });
  };

  const validateMobileHandler = () => {
    dispatchMobile({ type: "USER_BLUR" });
  };

  const submitHandler = (event) => {
    event.preventDefault();
    loginRequest();
  };

  const loginRequest = () => {
    const options = {
      method: "POST",
      url: "https://auth.best-fortuneteller.com/api/account/otp/request",
      data: {
        Msisdn: 2 + mobileState.value,
        SessionToken: sessionToken,
      },
      headers: {
        lang: i18n.language,
      },
    };
    sendRequest(options, setToken);
  };

  const setToken = (res) => {
    console.log(res)
    if (res.status === 200) {
      if (!res.data) {
        navigate(`/login-otp?msisdn=${2 + mobileState.value}`);
      } else {
        localStorage.setItem("token", res.data.token);
        navigate("/login-password?isExist=true", { replace: true });
      }
    }
  };

  return (
    <div className="mx-auto login pt-2">
      <div className="d-flex justify-content-end">
        <button
          className="login__change__language"
          onClick={() => changeLanguage(i18n.language === "ar" ? "en" : "ar")}
        >
          {i18n.language === "ar" ? "en" : "ar"}
        </button>
      </div>
      <div className="mx-auto text-center mt-4 mb-3">
        <img
          src={require("../../assets/img/logo/logo.png")}
          alt=""
          width="100px"
        />
      </div>
      <h1 className="text-center mb-5">{t("BestFortune")}</h1>

      <h3 className="text-white font-weight-light text-center h4">
        {t("StepAwayFortune")}
      </h3>
      <form onSubmit={submitHandler}>
        <Input
          ref={mobileInputRef}
          type="tel"
          id="mobile"
          onChange={mobileChangeHandler}
          onBlur={validateMobileHandler}
          onKeyDown={mobileKeyDownHandler}
          placeholder="01---------"
          pattern="01[0-9۰-۹٠-٩]{9}"
          state={mobileState}
          value={mobileState.value || "01"}
          maxLength="11"
          tabIndex={1}
        />

        <Button type="submit" className="w-50 mt-2" disabled={!formIsValid}>
          {t("Subscribe")}
        </Button>
      </form>

      <div className="error__message"> {error && "Invalid phone number"}</div>
      {i18n.language === "en" ? (
        <div className="regulation text-white ltr mt-5 px-2 mx-auto">
          You will subscribe to Best Fortune Teller for{" "}
          <span className="text-danger">5 Egyptian Pounds daily</span>{" "}
          auto-renewed & consumed from the internet bundle. To cancel your
          subscription, please send UNSUB BFT to 6699 for Vodafone subscribers,
          to 5030 for Orange, to 1722 for Etisalat and 4041 to We for free. To
          cancel from the site please go to
          https://best-fortuneteller.com/gen/unsub/request/en/bestfortuneteller
          and click on (unsubscribe). For any inquires please contact us by
          email at bestfortuneteller@portutel.com. Internet usage is deducted
          from your internet bundle. Terms and conditions apply.
        </div>
      ) : (
        <div className="regulation text-white rtl mt-5 px-2 mx-auto text-right">
          سوف تقوم بالاشتراك فى خدمة [بست فورتون تلر] مقابل
          <span className="text-danger"> 5 جنیه مصری یومیا</span> تجدد تلقائيا
          وتخصم من الباقة الخاصة بك.لالغاء الاشتراك مجانا, لعملاء Vodafone ارسل
          UNSUB BFT الى 6699 و 1722 Etisalat و 5030 orange و 4041 WE .للالغاء من
          الموقع بالرجاء الدخول ال
          https://bestfortuneteller.com/gen/unsub/request/en/bestfortuneteller و
          الضغط علي الغاء الاشتراك. لأية استفسارات يرجى التواصل معانا على
          bestfortuneteller@portutel.com .استهلاك الانترنت سوف يخصم من الباقة
          الخاصة بك. تطبق الشروط و الاحكام.
        </div>
      )}
    </div>
  );
};

export default Login;
